import { render, staticRenderFns } from "./agentList.vue?vue&type=template&id=023d7a82&scoped=true&"
import script from "./agentList.vue?vue&type=script&lang=js&"
export * from "./agentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d7a82",
  null
  
)

export default component.exports